import { useLayoutEffect, useRef, useState } from "react";
import { MARK_REVERSED, TILE_RADIUS, TILE_SCALE, TILE_TRANSFORM } from "./mark";
import "./brand.css";

/**
 * Loader de pantalla completa: el ícono de Mixcore girando como un vinilo
 * (33⅓ rpm). Mismo diseño que el de la web y que el splash de index.html:
 * el giro se ancla al reloj del documento, así que el relevo splash → loader
 * no se nota. Si al montarse el splash sigue en pantalla, no se re-anima.
 */
const GROOVES = [12.4, 14.6, 16.8, 19, 21.2, 23.4];
const LABEL_R = MARK_REVERSED.dotR * TILE_SCALE;

export function MixcoreLoader({ label = "Cargando…" }: { label?: string }) {
  const recordRef = useRef<SVGGElement>(null);
  const [animateIn] = useState(() => !document.getElementById("mx-splash"));

  useLayoutEffect(() => {
    try {
      recordRef.current?.getAnimations().forEach((a) => {
        a.startTime = 0;
      });
    } catch {
      // Sin Web Animations API gira igual, sólo sin sincronizarse.
    }
  }, []);

  return (
    <div className={`mx-vl mx-vl--page${animateIn ? " mx-vl--enter" : ""}`} role="status" aria-live="polite">
      <span className="mx-vl__disc">
        <svg className="mx-vl__svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
          <rect className="mx-vl__tile" width="100" height="100" rx={TILE_RADIUS} />
          <g className="mx-vl__grooves">
            {GROOVES.map((r) => (
              <circle key={r} cx="50" cy="50" r={r} />
            ))}
          </g>
          <g className="mx-vl__record" ref={recordRef}>
            <path transform={TILE_TRANSFORM} d={MARK_REVERSED.d} />
          </g>
          <circle className="mx-vl__label" cx="50" cy="50" r={LABEL_R} />
        </svg>
        <span className="mx-vl__sheen" />
      </span>
      <span className="mx-vl__sr">{label}</span>
    </div>
  );
}
